<template>
  <div class="SearchResponsesItemChat">
    <SearchResponsesItemChatText :result="result" class="SearchResponsesItemChat__result-text" />
    <SearchResponsesItemChatContext :result="result" class="SearchResponsesItemChat__context" />
    <SearchResponsesItemChatUser
      :result="result"
      :with-demographics="withDemographics"
      class="SearchResponsesItemChat__user"
    ></SearchResponsesItemChatUser>
  </div>
</template>

<script>
import SearchResponsesItemChatContext from '@/components/pages/search/SearchModule/SearchContent/SearchResponses/SearchResponsesItem/Chat/SearchResponsesItemChatContext'
import SearchResponsesItemChatUser from '@/components/pages/search/SearchModule/SearchContent/SearchResponses/SearchResponsesItem/Chat/SearchResponsesItemChatUser'
import ForumResponseModel from '@/models/forum/forumResponse'
import SearchResponsesItemChatText from '@/components/pages/search/SearchModule/SearchContent/SearchResponses/SearchResponsesItem/Chat/SearchResponsesItemChatText.vue'
export default {
  name: 'SearchResponsesItemChat',
  components: { SearchResponsesItemChatText, SearchResponsesItemChatUser, SearchResponsesItemChatContext },
  props: {
    result: { type: Object, required: true },
    withDemographics: { type: Boolean, default: false }
  },
  computed: {
    response() {
      return ForumResponseModel.parseFromApi({
        response: this.result.response,
        chatId: this.result?.chat?.id,
        threadId: this.result?.thread?.id,
        users: this.result?.users,
        prospects: this.result?.prospects
      })
    },
    text() {
      if (
        this.result?.highlight?.text ||
        this.result?.highlight?.translates ||
        this.result?.highlight?.transcribes
      ) {
        return (
          '...' +
          [
            this.result.highlight.text?.map((el) => el.replace('<p>', '').replace('</p>', '')),
            this.result.highlight.translates,
            this.result.highlight.transcribes
          ]
            .filter(Boolean)
            .flat(1)
            .join('...<br>...') +
          '...'
        )
      }
      if (this.result?.text || this.result?.translates || this.result?.transcribes) {
        return [this.result.text, this.result.translates, this.result.transcribes]
          .filter(Boolean)
          .flat(1)
          .join('<br>')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.SearchResponsesItemChat {
  &__result-text {
    @apply text-body-01 break-words;

    ::v-deep em {
      @apply bg-accent-03-200 not-italic;
    }
  }
  &__context {
    @apply w-full mt-2;
  }
  &__user {
    @apply mt-4;
  }
}
</style>
